import { instance } from '../rdpInstance';

export const sendCodeInLoginState = (param) => instance.post('verify/sendcodeinloginstate', param);

export const sendCodeInLoginStateByAccount = (param) => instance.post('verify/sendcodebyaccount', param);
